import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { IpdSkuPagedResultVO } from '../types';

export const ipdSkuApi = {
  getList: async (params: {
    ipcProjectId: number;
    scheduleId?: number;
    currentSpecId?: number;
    keyword?: string;
    sourceProjectWorkItemId?: number;
    status?: string;
    pageNum?: number;
    pageSize?: number;
  }): Promise<IpdSkuPagedResultVO> => {
    const queryParams = new URLSearchParams();
    queryParams.append('ipcProjectId', String(params.ipcProjectId));
    if (params.scheduleId) queryParams.append('scheduleId', String(params.scheduleId));
    if (params.currentSpecId) queryParams.append('currentSpecId', String(params.currentSpecId));
    if (params.keyword) queryParams.append('keyword', params.keyword);
    if (params.sourceProjectWorkItemId)
      queryParams.append('sourceProjectWorkItemId', String(params.sourceProjectWorkItemId));
    if (params.status) queryParams.append('status', params.status);
    if (params.pageNum) queryParams.append('pageNum', String(params.pageNum));
    if (params.pageSize) queryParams.append('pageSize', String(params.pageSize));

    const response = await fetch(`${API_ENDPOINTS.IPD_SKUS.LIST}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<IpdSkuPagedResultVO>(response);
  },
};
